export default __webpack_public_path__ + "static/media/homeBlogger.abcd6f3f.svg";